<template>
  <div style="height: 100%;">
    <div id="gjs" />
    <v-navigation-drawer
      id="panelsContainer"
      ref="panelsContainer"
      v-show="true"
      :permanent="true"
      :absolute="true"
      :style="{ transform: `translateX(${preview ? '-100%' : '0%'})` }"
      left
      style="z-index:14;"
      width="350"
      height="100%"
      color="grey lighten-2"
      class="pa-0"
    >
      <v-tabs
        ref="tabs-panel-views"
        v-model="manager.activeTab"
        :show-arrows="false"
        background-color="white"
        slider-size="4"
        fixed-tabs
        height="64px"
        icons-and-text
        centered
      >
        <template v-for="(tab, index) in panelTabs">
          <v-tab
            :ref="`tab-${tab.id}`"
            :id="`tab-${tab.id}`"
            :key="`tab-${tab.id}`"
            class="pa-0"
            style="min-width: 64px;"
          >
            <div style="font-size: .55rem;" class="mt-1 font-weight-bold">
              {{ tab.label }}
            </div>
            <v-icon v-text="tab.icon" :size="tab.iconSize" class="mt-2" />
          </v-tab>
          <v-divider v-if="index < panelTabs.length" :key="`tab-divider-${index}`" vertical />
        </template>
      </v-tabs>
      <v-divider />
      <v-tabs-items
        v-model="manager.activeTab"
        style="background-color: transparent;"
      >
        <v-tab-item
          ref="tab-item-0"
          :style="{ height: `calc(100vh - ${fullscreen ? '65px' : '129px'})` }"
          eager
          class="overflow-y-auto"
        >
          <v-container style="padding-bottom: 58px;">
            <v-row dense>
              <v-col v-if="!componentSelected" cols="12">
                <v-alert
                  text
                  dense
                  border="left"
                  color="blue"
                  class="ma-0"
                >
                  <span
                    v-text="'Por favor seleccione un componente para editar'"
                    class="text-left caption"
                  />
                </v-alert>
              </v-col>
              <v-col v-show="componentSelected" cols="12">
                <v-card id="selectorContainer" ref="selectorContainer" />
              </v-col>
              <!-- <v-col v-show="componentSelected" cols="12">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="pr-3 py-2" style="height: 40px;min-height: 40px; font-size: 12px;">
                      CSS rules
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pa-0 text-left">
                      <v-divider />
                      <v-card dark color="#10161f" tile>
                        <v-card-text>
                          <VueJsonPretty
                             v-if="componentSelected"
                            :data="componentSelected.getStyle()"
                            :showDoubleQuotes="false"
                          />
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col> -->
              <v-col v-show="componentSelected" cols="12">
                <v-card id="stylesContainer" ref="stylesContainer" />
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item
          ref="tab-item-1"
          :style="{ height: `calc(100vh - ${fullscreen ? '65px' : '129px'})` }"
          eager
          class="overflow-y-auto"
        >
          <v-container style="padding-bottom: 58px;">
            <v-row dense>
              <v-col v-if="!componentSelected" cols="12">
                <v-alert
                  text
                  dense
                  border="left"
                  color="blue"
                  class="ma-0"
                >
                  <span
                    v-text="'Por favor seleccione un componente para editar'"
                    class="text-left caption"
                  />
                </v-alert>
              </v-col>
              <v-col v-show="componentSelected" cols="12">
                <v-card id="traitsContainer" ref="traitsContainer" />
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <!-- <v-tab-item
          ref="tab-item-2"
          :style="{ height: `calc(100vh - ${fullscreen ? '65px' : '129px'})` }"
          eager
          class="overflow-y-auto"
        >
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-card id="layersContainer" ref="layersContainer" />
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item> -->
        <v-tab-item
          ref="tab-item-3"
          :style="{ height: `calc(100vh - ${fullscreen ? '65px' : '129px'})` }"
          eager
          class="overflow-y-auto"
        >
          <v-container style="padding-bottom: 58px;">
            <v-row dense>
              <v-col cols="12">
                <v-card id="blocksContainer" ref="blocksContainer" />
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
      <v-sheet
        id="button-group-control-b"
        ref="button-group-control-b"
        color="rgba(255,255,255,.9)"
        elevation="6"
        class="pa-0 ma-3 d-flex align-center"
        style="z-index: 11; position: absolute; bottom: 0; left: 0;"
      >
        <v-tooltip top color="black">
          <template v-slot:activator="{ on}">
            <v-btn
              id="button-undo"
              v-on="on"
              @click="undo()"
              color="primary"
              icon
              tile
              small
              class="ma-0 pa-0"
              height="36px"
              width="36px"
            >
              <v-icon v-text="'chevron_left'" />
            </v-btn>
          </template>
          <span v-text="'Undo'" class="caption" />
        </v-tooltip>
        <v-tooltip top color="black">
          <template v-slot:activator="{ on}">
            <v-btn
              @click="redo()"
              v-on="on"
              color="primary"
              icon
              tile
              small
              class="ma-0 pa-0"
              height="36px"
              width="36px"
            >
              <v-icon v-text="'chevron_right'" />
            </v-btn>
          </template>
          <span v-text="'Redo'" class="caption" />
        </v-tooltip>
        <v-divider class="grey lighten-1" vertical />
        <v-menu
          offset-y
          right
          top
          nudge-top="10px"
          min-width="216px"
          max-width="216px"
          style="z-index: 200;"
          attach="#button-group-control-b"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              ref="button-menu-translations"
              v-on="on"
              text
              tile
              small
              height="36px"
              width="216px"
              class="justify-start text-truncate caption px-4"
            >
              <div class="d-flex align-center">
                <v-icon
                  v-text="devices[deviceSelected].icon"
                  :size="devices[deviceSelected].iconSize"
                  :style="{ transform: devices[deviceSelected].transform ? devices[deviceSelected].transform : 'none' }"
                  color="primary"
                  class="mr-3"
                  style="width: 22px;"
                />
                <b
                  v-text="devices[deviceSelected].label"
                  style="font-size: .7rem;"
                />
                <v-spacer />
                <span
                  v-text="`${devices[deviceSelected].width}px`"
                  style="position:absolute; right: 0; font-size: .6rem;"
                />
              </div>
            </v-btn>
          </template>
          <v-card ref="content-menu-tags">
            <v-card-title class="subtitle-2">
              Media query
            </v-card-title>
            <v-divider />
            <v-card-text
              v-if="!devices.length"
              style="max-height: 400px; overflow-y: auto;"
              class="pa-4"
            >
              <v-row dense>
                <v-col>
                  <v-img
                    :src="require('@/assets/svg/box_empty.svg')"
                    height="150"
                    max-height="150px"
                    aspect-ratio="1"
                    contain
                  />
                  <div class="text-center">
                    {{ $t('common.no_results_found') }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-list v-else dense max-height="250px" class="overflow-y-auto">
              <v-list-item
                v-for="(device, index) in devices"
                @click="deviceSelected = index"
                :key="device.id"
              >
                <v-icon
                  v-text="device.icon"
                  :size="device.iconSize"
                  :style="{ transform: device.transform ? device.transform : 'none' }"
                  class="mr-3"
                  style="width: 22px;"
                />
                <v-list-item-content>
                  <v-list-item-title
                    v-text="device.label"
                    class="grey--text text--darken-1 text-left font-weight-bold"
                    style="font-size: .8rem;"
                  />
                </v-list-item-content>
                <v-list-item-action>
                  <span
                    v-text="`${device.width}px`"
                    class="grey--text"
                    style="font-size: .6rem;"
                  />
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
        <v-divider class="grey lighten-1" vertical />
        <v-menu
          :close-on-content-click="false"
          offset-y
          left
          top
          nudge-top="10px"
          min-width="280px"
          max-width="280px"
          style="z-index: 200;"
          attach="#button-group-control-b"
          eager
        >
          <template v-slot:activator="{ on: onMenu }">
            <v-tooltip top color="black">
              <template v-slot:activator="{ on: onTooltip }">
                <v-btn
                  v-on="{ ...onTooltip, ...onMenu }"
                  icon
                  tile
                  class="ma-0 pa-0"
                >
                  <v-icon v-text="'layers'" size="20" />
                </v-btn>
              </template>
              <span v-text="'Layers'" class="caption" />
            </v-tooltip>
          </template>
          <v-card ref="content-menu-tags">
            <v-card-title class="subtitle-2">
              Layers
            </v-card-title>
            <v-divider />
            <v-card-text
              id="layersContainer"
              ref="layersContainer"
              style="height: 300px; max-height: 300px;"
              class="overflow-y-auto pa-0 grey lighten-3"
            />
          </v-card>
        </v-menu>
      </v-sheet>
    </v-navigation-drawer>
    <v-btn
      ref="button-toggle-panels"
      @click="togglePreview()"
      color="primary"
      fab
      tile
      small
      absolute
      style="left: -14px; top: 50%; border-radius: 0 28px 28px 0;"
      class="pl-2"
    >
      <v-icon
        v-text="'chevron_right'"
        :style="{ transform: preview ? 'rotateZ(0deg)' : 'rotateZ(180deg)' }"
        style="transition: .3s;"
      />
    </v-btn>
    <v-sheet
      id="button-group-control-bl"
      ref="button-group-control-bl"
      color="rgba(255,255,255,.9)"
      elevation="6"
      class="pa-0 ma-3 d-flex align-center"
      style="z-index: 11; position: absolute; bottom: 0; left: 0;"
    >
      <!-- <v-tooltip top color="black">
        <template v-slot:activator="{ on}">
          <v-btn
            id="button-undo"
            v-on="on"
            @click="undo()"
            color="primary"
            icon
            tile
            small
            class="ma-0 pa-0"
            height="36px"
            width="36px"
          >
            <v-icon v-text="'chevron_left'" />
          </v-btn>
        </template>
        <span v-text="'Undo'" class="caption" />
      </v-tooltip>
      <v-tooltip top color="black">
        <template v-slot:activator="{ on}">
          <v-btn
            @click="redo()"
            v-on="on"
            color="primary"
            icon
            tile
            small
            class="ma-0 pa-0"
            height="36px"
            width="36px"
          >
            <v-icon v-text="'chevron_right'" />
          </v-btn>
        </template>
        <span v-text="'Redo'" class="caption" />
      </v-tooltip>
      <v-divider class="grey lighten-1" vertical />
      <v-menu
        offset-y
        right
        top
        nudge-top="10px"
        min-width="220px"
        max-width="220px"
        style="z-index: 200;"
        attach="#button-group-control-bl"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            ref="button-menu-translations"
            v-on="on"
            text
            tile
            small
            height="36px"
            width="220px"
            class="justify-start text-truncate caption px-4"
          >
            <div class="d-flex align-center">
              <v-icon
                v-text="devices[deviceSelected].icon"
                :size="devices[deviceSelected].iconSize"
                :style="{ transform: devices[deviceSelected].transform ? devices[deviceSelected].transform : 'none' }"
                color="primary"
                class="mr-3"
                style="width: 22px;"
              />
              <b
                v-text="devices[deviceSelected].label"
                style="font-size: .7rem;"
              />
              <v-spacer />
              <span
                v-text="`${devices[deviceSelected].width}px`"
                style="position:absolute; right: 0; font-size: .6rem;"
              />
            </div>
          </v-btn>
        </template>
        <v-card ref="content-menu-tags">
          <v-card-title>
            Media query
          </v-card-title>
          <v-divider />
          <v-card-text
            v-if="!devices.length"
            style="max-height: 400px; overflow-y: auto;"
            class="pa-4"
          >
            <v-row dense>
              <v-col>
                <v-img
                  :src="require('@/assets/svg/box_empty.svg')"
                  height="150"
                  max-height="150px"
                  aspect-ratio="1"
                  contain
                />
                <div class="text-center">
                  {{ $t('common.no_results_found') }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-list v-else dense max-height="250px" class="overflow-y-auto">
            <v-list-item
              v-for="(device, index) in devices"
              @click="deviceSelected = index"
              :key="device.id"
            >
              <v-icon
                v-text="device.icon"
                :size="device.iconSize"
                :style="{ transform: device.transform ? device.transform : 'none' }"
                class="mr-3"
                style="width: 22px;"
              />
              <v-list-item-content>
                <v-list-item-title
                  v-text="device.label"
                  class="grey--text text--darken-1 font-weight-bold"
                  style="font-size: .8rem;"
                />
              </v-list-item-content>
              <v-list-item-action>
                <span
                  v-text="`${device.width}px`"
                  class="grey--text"
                  style="font-size: .6rem;"
                />
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
      <v-divider class="grey lighten-1" vertical />
      <v-menu
        :close-on-click="false"
        offset-y
        left
        top
        nudge-top="10px"
        min-width="280px"
        max-width="280px"
        style="z-index: 200;"
        attach="#button-group-control-bl"
        eager
      >
        <template v-slot:activator="{ on: onMenu }">
          <v-tooltip top color="black">
            <template v-slot:activator="{ on: onTooltip }">
              <v-btn
                v-on="{ ...onTooltip, ...onMenu }"
                icon
                tile
                class="ma-0 pa-0"
              >
                <v-icon v-text="'layers'" size="20" />
              </v-btn>
            </template>
            <span v-text="'Layers'" class="caption" />
          </v-tooltip>
        </template>
        <v-card ref="content-menu-tags">
          <v-card-title>
            Layers
          </v-card-title>
          <v-divider />
          <v-card-text
            id="layersContainer"
            ref="layersContainer"
            style="height: 300px; max-height: 300px;"
            class="overflow-y-auto pa-0 grey lighten-3"
          />
        </v-card>
      </v-menu>
      <v-divider class="grey lighten-1" vertical /> -->
      <v-tooltip top color="black">
        <template v-slot:activator="{ on }">
          <v-btn
            @click="toggleSWVisibility()"
            v-on="on"
            icon
            tile
            class="ma-0 pa-0"
          >
            <v-icon v-text="swVisibility ? 'grid_off' : 'grid_on'" size="20" />
          </v-btn>
        </template>
        <span v-text="'Component borders'" class="caption" />
      </v-tooltip>
      <v-divider class="grey lighten-1" vertical />
      <v-tooltip top color="black">
        <template v-slot:activator="{ on}">
          <v-btn
            v-on="on"
            @click="toggleFullscreen()"
            icon
            tile
            class="ma-0 pa-0"
          >
            <v-icon v-text="fullscreen ? 'fullscreen_exit' : 'fullscreen'" />
          </v-btn>
        </template>
        <span v-text="'Fullscreen'" class="caption" />
      </v-tooltip>
      <v-divider class="grey lighten-1" vertical />
      <v-tooltip top color="black">
        <template v-slot:activator="{ on}">
          <v-btn
            v-on="on"
            @click="toggleDialogCode(true)"
            icon
            tile
            class="ma-0 pa-0"
          >
            <v-icon v-text="'code'" size="24" />
          </v-btn>
        </template>
        <span v-text="'Code'" class="caption" />
      </v-tooltip>
      <v-divider class="grey lighten-1" vertical />
      <v-tooltip top color="black">
        <template v-slot:activator="{ on}">
          <v-btn
            v-on="on"
            @click="toggleDialogImport(true)"
            icon
            tile
            class="ma-0 pa-0"
          >
            <v-icon v-text="'content_paste'" size="18" />
          </v-btn>
        </template>
        <span v-text="$t('actions.import')" class="caption" />
      </v-tooltip>
      <div id="attach-items" style="position: relative; top: 0; width: 100%;" />
    </v-sheet>
    <v-dialog
      ref="dialog-code"
      v-model="dialogCode.display"
      persistent
      width="800px"
      style="z-index: 200;"
      eager
    >
      <v-card class="pa-0">
        <v-card-title class="pa-0 pl-3" style="height: 36px;">
          <div class="subtitle-2 d-flex align-center">
            <v-icon v-text="'code'" left color="primary" />
            <b v-text="'Code'" />
          </div>
          <v-btn
            @click="toggleDialogCode(false)"
            color="error"
            tile
            icon
            absolute
            style="top: 0; right: 0;"
          >
            <v-icon v-text="'close'" />
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-tabs
          v-model="dialogCode.activeTab"
          background-color="white"
          height="36px"
          slider-size="4"
        >
          <v-tab ref="tab-header-0" style="width: 72px;">
            <div v-text="'HTML'" class="mt-1" />
          </v-tab>
          <v-divider vertical />
          <v-tab ref="tab-header-1" style="width: 72px;">
            <div v-text="'CSS'" class="mt-1" />
          </v-tab>
          <v-divider vertical />
          <v-tab ref="tab-header-2" style="width: 72px;">
            <div v-text="'JS'" class="mt-1" />
          </v-tab>
          <v-divider vertical />
        </v-tabs>
        <v-divider />
        <v-tabs-items v-model="dialogCode.activeTab">
          <v-tab-item ref="tab-item-0" eager>
            <codemirror
              ref="codemirrorHtml"
              v-model="codeHtml"
              :options="codemirrorOptions"
              @refresh="codemirrorLoaded"
            />
          </v-tab-item>
          <v-tab-item ref="tab-item-1" eager>
            <codemirror
              ref="codemirrorCss"
              v-model="codeCss"
              :options="{ ...codemirrorOptions, mode: 'css' }"
              @refresh="codemirrorLoaded"
            />
          </v-tab-item>
          <v-tab-item ref="tab-item-2" eager>
            <codemirror
              ref="codemirrorJs"
              v-model="codeJs"
              :options="{ ...codemirrorOptions, mode: 'text/javascript' }"
              @refresh="codemirrorLoaded"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
    <v-dialog
      ref="dialog-import"
      v-model="dialogImport.display"
      persistent
      eager
      width="800px"
      style="z-index: 200;"
    >
      <v-card class="pa-0">
        <v-card-title class="pa-0 pl-3" style="height: 36px;">
          <div class="subtitle-2 d-flex align-center">
            <v-icon v-text="'code'" left color="primary" />
            <b v-text="`${$t('actions.import')} Code`" />
          </div>
          <v-btn
            @click="toggleDialogImport(false)"
            color="error"
            tile
            icon
            absolute
            style="top: 0; right: 0;"
          >
            <v-icon v-text="'close'" />
          </v-btn>
        </v-card-title>
        <v-divider />
        <codemirror v-model="codeImport" :options="codemirrorOptions" />
        <v-btn
          @click="importHtml()"
          color="primary"
          absolute
          small
          style="bottom: 0; right: 0; z-index: 5;"
          class="ma-4"
        >
          {{ $t('actions.import') }}
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'
import config from '@/config'
import grapesjs from 'grapesjs'
import grapesjsCustomCode from 'grapesjs-custom-code/dist/grapesjs-custom-code.min'
import grapesjsPluginForms from 'grapesjs-plugin-forms/dist/grapesjs-plugin-forms.min'
import grapesjsStyleFilter from 'grapesjs-style-filter/dist/grapesjs-style-filter.min'
import grapesjsTuiImageEditor from 'grapesjs-tui-image-editor/dist/grapesjs-tui-image-editor.min'

import BASE64 from '@/data/base64'
import VueJsonPretty from 'vue-json-pretty'
import grapesjsAccordion from './plugins/Accordion'
import grapesjsSlider from './plugins/Slider'
import AfrusFormComponent from './components/AfrusForm'
import ButtonComponent from './components/Button'
import ColComponent from './components/Col'
import ContainerComponent from './components/Container'
import RowComponent from './components/Row'
import SpacerComponent from './components/Spacer'
import DividerComponent from './components/Divider'
import ImageComponent from './components/Image'
import InputComponent from './components/Input'
import SelectComponent from './components/Select'
import TextFieldComponent from './components/TextField'
import TextareaComponent from './components/Textarea'
import BlockManager from './BlockManager/index'
import 'grapesjs/dist/css/grapes.min.css'
import 'vue-json-pretty/lib/styles.css'

export default {
  name: 'GrapsJS',
  components: { VueJsonPretty },
  props: {
    type: {
      type: String,
      default: '',
      required: true
    },
    template: {
      type: String,
      default: '',
      required: true
    },
    links: {
      type: Array,
      default: [],
      required: false
    }
  },
  data () {
    return {
      editor: null,
      componentSelected: null,
      manager: {
        display: false,
        activeTab: 3
      },
      dialogCode: {
        display: false,
        activeTab: 0
      },
      dialogImport: { display: false },
      deviceSelected: 0,
      preview: false,
      fullscreen: false,
      swVisibility: false,
      devices: [
        {
          value: 'Desktop',
          label: 'Escritorio',
          icon: 'desktop_windows',
          iconSize: 22,
          width: 1080
        },
        {
          value: 'Tablet',
          label: 'Tablet',
          icon: 'tablet_mac',
          iconSize: 18,
          width: 992
        },
        {
          value: 'Mobile landscape',
          label: 'Smartphone',
          icon: 'phone_iphone',
          iconSize: 20,
          transform: 'rotateZ(-90deg)',
          width: 768
        },
        {
          value: 'Mobile portrait',
          label: 'Smartphone',
          icon: 'phone_iphone',
          iconSize: 20,
          width: 480
        }
      ],
      panelTabs: [
        {
          id: 'styles',
          label: 'Styles',
          command: 'open-sm',
          icon: 'color_lens',
          iconSize: 24
        },
        {
          id: 'settings',
          label: 'Settings',
          command: 'open-tm',
          icon: 'settings',
          iconSize: 22
        },
        // {
        //   id: 'layers',
        //   label: 'Layers',
        //   command: 'open-layers',
        //   icon: 'layers',
        //   iconSize: 24
        // },
        {
          id: 'components',
          label: 'Components',
          command: 'open-blocks',
          icon: 'view_quilt',
          iconSize: 28
        }
      ],
      options: [
        { }
      ],
      codeImport: '',
      codeHtml: '',
      codeCss: '',
      codeJs: '',
      blocks: [],
      blockCategories: [],
      sectors: {},
      codemirrorOptions: {
        tabSize: 2,
        mode: 'text/html',
        theme: 'monokai',
        lineNumbers: true,
        lineWrapping: true,
        line: true,
        readOnly: false,
        styleActiveLine: true
      }
    }
  },
  computed: {
    ...mapState({ organizationId: ({ auth: { organizationId } }) => organizationId }),
    ...mapGetters({
      images: 'images/images',
      landing: 'landing/landings/landing'
    }),
    stylesByType () {
      if (['landing'].includes(this.type)) {
        return `
          <link class="afrus-css" href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css" rel="stylesheet">
          <link class="afrus-css" href="${config.backendURL}/grapesjs/web/style.css" rel="stylesheet">
          {{headers}}
        `
      }
      if (['thank_you_page'].includes(this.type)) {
        return `
          <link class="afrus-css" href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css" rel="stylesheet">
          <link class="afrus-css" href="${config.backendURL}/grapesjs/web/style.css" rel="stylesheet">
        `
      }
      return ''
    },
    scriptsByType () {
      if (['landing'].includes(this.type)) {
        return `
          <script class="afrus-script" type="text/javascript" src="${config.backendURL}/template/index.js"><\/script>
          <script class="afrus-script" type="text/javascript" src="${config.backendURL}/grapesjs/web/index.js"><\/script>
          <script class="afrus-script" data-org="{{organization_id}}" data-landing="{{landing_id}}" src="${config.backendURL}/tracking.js"><\/script>
          {{scripts}}
        `
      }
      if (['thank_you_page'].includes(this.type)) {
        return `<script class="afrus-script" type="text/javascript" src="${config.backendURL}/grapesjs/web/index.js"><\/script>`
      }
      return ''
    },
    canvasStyles () {
      const styles = [
        {
          class: 'afrus-css',
          href: 'https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css'
        },
        {
          class: 'afrus-css',
          href: `${config.backendURL}/grapesjs/web/style.css`
        }
      ]
      this.links.forEach(({ source }) => {
        styles.push({
          class: 'afrus-css',
          href: source
        })
      })
      return styles
    },
    blockManager () {
      return this.editor.BlockManager
    },
    styleManager () {
      return this.editor.StyleManager
    },
    assetManager () {
      return this.editor.AssetManager
    },
    domComponents () {
      return this.editor.DomComponents
    },
    commands () {
      return this.editor.Commands
    },
    panelManager () {
      return this.editor.Panels
    },
    selectorManager () {
      return this.editor.SelectorManager
    },
    cssComposer () {
      return this.editor.CssComposer
    },
    canvas () {
      return this.editor.Canvas
    },
    textEditor () {
      return this.editor.RichTextEditor
    },
    allBlock () {
      return this.blockManager.getAll()
    },
    codemirrorHtml () {
      return this.$refs.codemirrorHtml.codemirror
    },
    codemirrorCss () {
      return this.$refs.codemirrorCss.codemirror
    },
    codemirrorJs () {
      return this.$refs.codemirrorJs.codemirror
    }
  },
  watch: {
    deviceSelected (newVal) {
      this.editor.setDevice(this.devices[this.deviceSelected].value)
    },
    preview (newVal) {
      this.canvas.getElement().classList.toggle('gjs-cv-canvas--preview')
    }
  },
  async mounted () {
    const that = this

    await this.initializeEditor()
    await this.loadPanelsEditor()

    this.domComponents.addType('grid-container', ContainerComponent)
    this.domComponents.addType('grid-row', RowComponent)
    this.domComponents.addType('grid-col', ColComponent)
    this.domComponents.addType('spacer', SpacerComponent)
    this.domComponents.addType('divider', DividerComponent)
    this.domComponents.addType('image', ImageComponent)
    this.domComponents.addType('input', InputComponent)
    this.domComponents.addType('button', ButtonComponent)
    this.domComponents.addType('select', SelectComponent)
    this.domComponents.addType('text-field', TextFieldComponent)
    this.domComponents.addType('textarea', TextareaComponent)
    this.domComponents.addType('afrus-form', {
      isComponent: el => el.tagName === 'DIV' && el.id.includes('afrus-container-form'),
      model: {
        defaults: Object.assign({}, {
          tagName: 'div',
          removable: true,
          draggable: true,
          droppable: false,
          stylable: true,
          selectable: true,
          attributes: {
            id: 'afrus-container-form',
            'data-landing': '{{landing_id}}',
            'attr-type': '1',
            'data-form': ''
          },
          style: { 'min-height': '48px' },
          traits: model => [
            {
              name: 'attr-type',
              label: 'Type',
              placeholder: 'Type',
              type: 'select',
              options: [
                { id: '1', name: 'Lead forms' },
                { id: '9', name: 'Advanced lead forms' },
                { id: '2', name: 'Domation forms' }
              ]
            },
            {
              name: 'data-form',
              label: 'Form',
              placeholder: 'Form',
              type: 'select',
              options: []
            }
          ]
        }),
        init () {
          this.on('change:attributes:attr-type', this.handleTypeChange)
          this.on('change:attributes:data-form', this.handleFormChange)
        },
        handleTypeChange () {
          this.setId('afrus-container-form')
          const type = this.getAttributes()['attr-type']
          this.addAttributes({ 'data-form': '' })
          this.getTrait('data-form').set('options', [])
        },
        handleFormChange () {
          this.setId('afrus-container-form')
          setTimeout(() => that.loadAfrusScript(), 300)
        }
      }
    })

    BlockManager.forEach(e => {
      if (e.types.includes(this.type)) {
        this.blockManager.add(e.block, e.opts)
      }
    })

    this.editor.setComponents(this.template
      .replace(/<script(?=[^>]*class="afrus-script")[^>]*>[^>]*<\/script>/g, '')
      .replace(/<link(?=[^>]*class="afrus-css")[^>]*>/g, '')
      .replace(/<meta(?=[^>]*class="afrus-meta")[^>]*>/g, '')
      .replace(/<title(?=[^>]*class="afrus-meta")[^>]*>[^>]*<\/title>/g, '')
      .replace('{{headers}}', '')
      .replace('{{scripts}}', ''))

    this.editor.on('load', () => {
      this.panelManager.removePanel('devices-c')
      this.panelManager.removePanel('commands')
      this.panelManager.removePanel('options')
      this.editor.DomComponents.getWrapper().set({ badgable: false, selectable: true })
      this.toggleSWVisibility()
      this.loadAfrusScript()
    })
    this.editor.on('update', () => {
      this.$emit('change', this.getHtml())
    })
    this.editor.on('component:create', component => {
      setTimeout(() => {
        this.editor.select(component)
        this.manager.activeTab = 0
      }, 1)
    })
    this.editor.on('component:remove', component => {
      this.manager.activeTab = 3
    })
    this.editor.on('component:deselected', component => {
      this.componentSelected = null
    })
    this.editor.on('component:selected', component => {
      this.componentSelected = component
      this.manager.activeTab = 0
    })
    this.editor.on('run', command => {
      if (command === 'fullscreen') {
        that.fullscreen = true
      }
      if (command === 'sw-visibility') {
        that.swVisibility = true
      }
    })
    this.editor.on('stop', command => {
      if (command === 'fullscreen') {
        that.fullscreen = false
      }
      if (command === 'sw-visibility') {
        that.swVisibility = false
      }
    })
    this.getBlocks()
    this.getBlockCategories()
    this.getSectors()

    // window.editor = this.editor
  },
  methods: {
    ...mapActions({
      getImages: 'images/getImages',
      saveImage: 'images/saveImage',
      removeImage: 'images/removeImage'
    }),
    setFormCode (id) {
      const cryptForm = BASE64.encode(`form-${id}-organization-${this.organizationId}`)
      return cryptForm
    },
    initializeEditor () {
      const that = this

      const fonts = [
        'Arial, Helvetica, sans-serif',
        'Arial Black, Gadget, sans-serif',
        'Brush Script MT, sans-serif',
        'Comic Sans MS, cursive, sans-serif',
        'Courier New, Courier, monospace',
        'Georgia, serif',
        'Helvetica, sans-serif',
        'Impact, Charcoal, sans-serif',
        'Lucida Sans Unicode, Lucida Grande, sans-serif',
        'Tahoma, Geneva, sans-serif',
        'Times New Roman, Times, serif',
        'Trebuchet MS, Helvetica, sans-serif',
        'Verdana, Geneva, sans-serif'
      ]

      this.links.map(link => {
        fonts.unshift(link.name)
      })

      this.editor = grapesjs.init({
        container: '#gjs',
        height: '100%',
        fromElement: 1,
        allowScripts: 1,
        storageManager: 0,
        showOffsets: 1,
        showOffsetsSelected: 1,
        showDevices: 0,
        exportWrapper: 0,
        wrapperIsBody: 0,
        mediaCondition: 'max-width',
        protectedCss: '',
        layerManager: { appendTo: '#layersContainer' },
        selectorManager: {
          appendTo: '#selectorContainer',
          componentFirst: 1
        },
        styleManager: {
          appendTo: '#stylesContainer',
          clearProperties: 1,
          sectors: [
            {
              name: 'Position',
              open: false,
              buildProps: [
                'float',
                'display',
                'position',
                'top',
                'right',
                'left',
                'bottom'
              ]
            },
            {
              name: 'Flex',
              open: false,
              buildProps: [
                'flex-direction',
                'flex-wrap',
                'justify-content',
                'align-items',
                'align-content',
                'order',
                'flex-basis',
                'flex-grow',
                'flex-shrink',
                'align-self'
              ]
            },
            {
              name: 'Dimension',
              open: false,
              buildProps: [
                'width',
                'height',
                'min-width',
                'min-height',
                'max-width',
                'max-height',
                'margin',
                'padding'
              ]
            },
            {
              name: 'Typography',
              open: false,
              buildProps: [
                'font-family',
                'font-size',
                'font-weight',
                'letter-spacing',
                'color',
                'line-height',
                'text-decoration',
                'text-align',
                'text-shadow'
              ],
              properties: [
                {
                  property: 'font-family',
                  list: fonts.map(font => ({ name: font.split(',')[0], value: font }))
                },
                {
                  property: 'text-decoration',
                  type: 'select',
                  defaults: 'none',
                  list: [
                    { value: 'none', name: 'none' },
                    { value: 'overline', name: 'overline' },
                    { value: 'underline', name: 'underline' },
                    { value: 'line-through', name: 'line-through' }
                  ]
                },
                {
                  property: 'text-align',
                  list: [
                    { value: 'left', className: 'fa fa-align-left' },
                    { value: 'center', className: 'fa fa-align-center' },
                    { value: 'right', className: 'fa fa-align-right' },
                    { value: 'justify', className: 'fa fa-align-justify' }
                  ]
                }
              ]
            },
            {
              name: 'Decorations',
              open: false,
              buildProps: [
                'background-color',
                'background',
                'box-shadow'
              ]
            },
            {
              name: 'Borders',
              open: false,
              buildProps: [
                'border',
                'border-top',
                'border-right',
                'border-bottom',
                'border-left',
                'border-radius-c',
                'border-radius'
              ],
              properties: [
                {
                  property: 'border-top',
                  name: 'Border top',
                  type: 'composite',
                  properties: [
                    { defaults: 'medium', name: 'Border width', property: 'border-top-width', type: 'integer', units: ['px', '%'], unit: 'px' },
                    { defaults: 'solid', name: 'Border style', property: 'border-top-style', type: 'select', list: [{ value: 'none' }, { value: 'solid' }, { value: 'dotted' }, { value: 'dashed' }, { value: 'double' }, { value: 'groove' }, { value: 'ridge' }, { value: 'inset' }, { value: 'outset' }] },
                    { defaults: 'black', name: 'Border color', property: 'border-top-color', type: 'color' }
                  ]
                },
                {
                  property: 'border-right',
                  name: 'Border right',
                  type: 'composite',
                  properties: [
                    { defaults: 'medium', name: 'Border width', property: 'border-right-width', type: 'integer', units: ['px', '%'], unit: 'px' },
                    { defaults: 'solid', name: 'Border style', property: 'border-right-style', type: 'select', list: [{ value: 'none' }, { value: 'solid' }, { value: 'dotted' }, { value: 'dashed' }, { value: 'double' }, { value: 'groove' }, { value: 'ridge' }, { value: 'inset' }, { value: 'outset' }] },
                    { defaults: 'black', name: 'Border color', property: 'border-right-color', type: 'color' }
                  ]
                },
                {
                  property: 'border-bottom',
                  name: 'Border bottom',
                  type: 'composite',
                  properties: [
                    { defaults: 'medium', name: 'Border width', property: 'border-bottom-width', type: 'integer', units: ['px', '%'], unit: 'px' },
                    { defaults: 'solid', name: 'Border style', property: 'border-bottom-style', type: 'select', list: [{ value: 'none' }, { value: 'solid' }, { value: 'dotted' }, { value: 'dashed' }, { value: 'double' }, { value: 'groove' }, { value: 'ridge' }, { value: 'inset' }, { value: 'outset' }] },
                    { defaults: 'black', name: 'Border color', property: 'border-bottom-color', type: 'color' }
                  ]
                },
                {
                  property: 'border-left',
                  name: 'Border left',
                  type: 'composite',
                  properties: [
                    { defaults: 'medium', name: 'Border width', property: 'border-left-width', type: 'integer', units: ['px', '%'], unit: 'px' },
                    { defaults: 'solid', name: 'Border style', property: 'border-left-style', type: 'select', list: [{ value: 'none' }, { value: 'solid' }, { value: 'dotted' }, { value: 'dashed' }, { value: 'double' }, { value: 'groove' }, { value: 'ridge' }, { value: 'inset' }, { value: 'outset' }] },
                    { defaults: 'black', name: 'Border color', property: 'border-left-color', type: 'color' }
                  ]
                }
              ]
            },
            {
              name: 'Extra',
              open: false,
              buildProps: ['transition', 'perspective', 'transform', 'filter'],
              properties: [
                {
                  name: 'Filter',
                  property: 'filter',
                  type: 'filter',
                  full: 1
                }
              ]
            }
          ]
        },
        blockManager: { appendTo: '#blocksContainer' },
        traitManager: { appendTo: '#traitsContainer' },
        deviceManager: {
          devices: [
            {
              id: 'desktop',
              name: 'Desktop'
            },
            {
              id: 'tablet',
              name: 'Tablet',
              width: '991px',
              widthMedia: '992px'
            },
            {
              id: 'mobileLandscape',
              name: 'Mobile landscape',
              width: '767px',
              widthMedia: '768px'
            },
            {
              id: 'mobilePortrait',
              name: 'Mobile portrait',
              width: '479px',
              widthMedia: '480px'
            }
          ]
        },
        plugins: [
          grapesjsStyleFilter,
          grapesjsCustomCode,
          grapesjsPluginForms,
          grapesjsTuiImageEditor,
          grapesjsAccordion,
          grapesjsSlider
        ],
        pluginsOpts: {
          [grapesjsCustomCode]: {
            blockCustomCode: {
              category: 'Basic',
              content: { type: 'custom-code' },
              label: `
                <div class="d-flex flex-column align-center justify-center">
                  <i class="v-icon notranslate material-icons theme--light" style="font-size: 40px;">code</i>
                  <div class="overline">HTML</div>
                </div>
              `
            }
          },
          [grapesjsPluginForms]: { blocks: [] },
          [grapesjsTuiImageEditor]: {}
        },
        assetManager: {
          assets: this.images.map(image => image.url),
          uploadFile: e => {
            const { type: templateType, assetManager } = this
            const files = e.dataTransfer ? e.dataTransfer.files : e.target.files
            for (let i = 0; i < files.length; i++) {
              const file = files[i]
              const { name, size, type } = file
              const fr = new FileReader()
              if (type.split('/').includes('image')) {
                if (size < 1000000) {
                  fr.readAsDataURL(file)
                  fr.addEventListener('load', async () => {
                    const data = {
                      path: `templates`,
                      name,
                      size,
                      type,
                      content: fr.result
                    }
                    const res = await this.saveImage(data)
                    assetManager.add(res.url)
                  })
                } else {
                  this.$noty.error(this.$t('reports.message.errors.fileSize', null, { size: '1' }))
                }
              } else {
                this.$noty.error(this.$t('images.messages.error.invalid_type'))
              }
            }
          }
        },
        canvas: {
          scripts: [
            {
              class: 'afrus-script',
              src: `${config.backendURL}/template/index.js`
            },
            {
              class: 'afrus-script',
              src: `${config.backendURL}/grapesjs/web/index.js`,
              'data-manual': 1
            }
          ],
          styles: this.canvasStyles
        },
        panels: {
          defaults: [
            {
              id: 'styles',
              el: '#panelsContainer'
            },
            {
              id: 'layers',
              el: '#panelsContainer'
            },
            {
              id: 'blocks',
              el: '#panelsContainer'
            },
            {
              id: 'traits',
              el: '#panelsContainer'
            }
          ]
        }
      })
    },
    loadAfrusScript () {
      this.canvas.getWindow().AfrusForms.Inicializate()
    },
    loadAfrusComponents () {
      this.canvas.getWindow().AfrusEditor.loadComponents()
    },
    loadPanelsEditor () {
      this.editor.Canvas.getElement().append(this.$refs['button-toggle-panels'].$el)
      this.editor.Canvas.getElement().append(this.$refs['button-group-control-bl'].$el)
      this.editor.Panels.getPanelsEl().append(this.$refs['dialog-code'].$el)
      this.editor.Panels.getPanelsEl().append(this.$refs['dialog-import'].$el)
      this.editor.Panels.getPanelsEl().append(this.$refs.panelsContainer.$el)
    },
    getBlocks () {
      this.blocks = JSON.parse(JSON.stringify(this.blockManager.getAll()))
    },
    getBlockCategories () {
      this.blockCategories = JSON.parse(JSON.stringify(this.blockManager.getCategories()))
    },
    getSectors () {
      this.sectors = this.styleManager.getSectors()
    },
    undo () {
      const um = this.editor.UndoManager
      if (um.hasUndo()) { um.undo() }
    },
    redo () {
      const um = this.editor.UndoManager
      if (um.hasRedo()) { um.redo() }
    },
    clear () {
      const um = this.editor.UndoManager
      um.clear()
    },
    getHtml () {
      const resultHTML = `
        <!DOCTYPE html>
        <html>
          <head>
            ${this.stylesByType}
            <title class="afrus-meta">{{title}}</title>
            <style type="text/css">
              ${this.editor.getCss()}
            </style>
            <meta class="afrus-meta" name="viewport" content="width=device-width, initial-scale=1.0">
          </head>
          <body id="wrapper">
            ${this.editor.getHtml()}
            ${this.scriptsByType}
          </body>
        </html>
      `
      return resultHTML
    },
    importHtml () {
      this.editor.setComponents(this.codeImport)
      this.toggleDialogImport(false)
    },
    async exportHtml () {
      this.codeHtml = await this.getHtml()
    },
    async exportCss () {
      this.codeCss = await this.editor.getCss()
    },
    async exportJs () {
      this.codeJs = await this.editor.getJs()
    },
    async toggleDialogCode (display) {
      if (display) {
        await this.exportHtml()
        await this.exportCss()
        await this.exportJs()
        this.codemirrorHtml.refresh()
        this.codemirrorCss.refresh()
        this.codemirrorJs.refresh()
      }
      this.dialogCode.display = display
    },
    codemirrorLoaded (editor) {
      this.formatCode(editor)
    },
    async formatCode (editor) {
      editor.execCommand('selectAll')
      await this.autoFormatSelection(editor)
      editor.execCommand('goDocStart')
    },
    getSelectedRange (editor) {
      return { from: editor.getCursor(true), to: editor.getCursor(false) }
    },
    async autoFormatSelection (editor) {
      const range = this.getSelectedRange(editor)
      await editor.autoFormatRange(range.from, range.to)
    },
    openDialogCode () {
      this.commands.run('export-template')
    },
    toggleDialogImport (display) {
      // if (display) {
      //   this.togglePreview(false)
      //   this.toggleFullscreen(false)
      // }
      this.dialogImport.display = display
    },
    toggleSWVisibility (active) {
      if (this.commands.isActive('sw-visibility') && !active) {
        this.commands.stop('sw-visibility')
      } else {
        this.commands.run('sw-visibility')
      }
    },
    togglePreview (active) {
      this.preview = !this.preview
    },
    toggleFullscreen (active) {
      if (this.commands.isActive('fullscreen') && !active) {
        this.commands.stop('fullscreen')
      } else {
        this.commands.run('fullscreen')
      }
    }
  }
}
</script>
<style>
#gjs {
  border: none;
}
.gjs-one-bg {
  background-color: #ffffff;
}
.gjs-two-color {
  color: #373737;
}
.gjs-three-bg {
  background-color: #1976d2;
  color: white;
}
.gjs-four-color,
.gjs-four-color-h:hover {
  color:#4396e9;
}
.gjs-cv-canvas {
  top: 0;
  left: 350px;
  height: 100%;
  width: calc(100% - 350px);
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: width, left;
  background-color: #37474F;
  background-image: linear-gradient(45deg, #263238 25%, transparent 25%), linear-gradient(-45deg, #263238 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #263238 75%), linear-gradient(-45deg, transparent 75%, #263238 75%);
  background-size: 20px 20px;
  background-position: 0px 0px, 0px 10px, 10px -10px, -10px 0px;
  background-repeat: repeat;
}
.gjs-cv-canvas.gjs-cv-canvas--preview {
  left: 0;
  width: 100%;
}
.gjs-pn-commands {
  width: calc(100% - 350px);
}
.gjs-pn-options {
  left: 350px;
}
.gjs-pn-views {
  width: 350px;
  border: none;
  box-shadow: 0px 1px 4px 0px rgba(0,0,0,.5);
}
.gjs-pn-views-container {
  width: 350px;
}
.gjs-off-prv {
  display: none !important;
}
.gjs-blocks-c {
  padding: 5px;
}
.gjs-block {
  margin: 0;
  padding: 5px;
  width: 50%;
  box-shadow: none;
  border: none;
}
.gjs-block:hover {
    box-shadow: none;
}
.gjs-block-label {
  width: 100%;
  height: 100%;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-duration: .5s;
  border: 1px solid rgba(0,0,0,0.15);
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.15);
}
.gjs-block-label:hover {
  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.2);
}

.gjs-layer-vis {
  height: 32px !important;
  width: auto !important;
  left: 0;
  top: 0;
  padding: 8px 5px 10px 10px;
  position: absolute;
  cursor: pointer;
  z-index: 1;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-content: ;
  align-items: center;
}
.gjs-layer-title {
  height: 32px;
  display: flex;
  align-items: center;
}

.gjs-category-title, .gjs-sm-sector .gjs-sm-title, .gjs-clm-tags .gjs-sm-title, .gjs-block-category .gjs-title, .gjs-layer-title {
  font-weight: lighter;
  background-color: rgba(0,0,0,0.1);
  letter-spacing: 0;
  padding: none;
  border: none;
  outline: 1px solid rgba(0,0,0,0.1);
  text-align: left;
  position: relative;
  cursor: pointer;
}
.gjs-layer-title-inn {
    align-items: center;
    position: relative;
    display: flex;
    width: 100%;
}
.gjs-layer-name {
    padding: 2px 0 0 0;
    display: inline-block;
    box-sizing: content-box;
    overflow: hidden;
    white-space: nowrap;
    margin: 0 30px 0 5px;
    height: 100%;
}
.gjs-layer-caret {
    font-size: 0.5rem;
    width: auto;
    padding: 0;
    cursor: pointer;
    position: absolute;
    left: -8px;
    top: auto;
    opacity: .7;
}
.gjs-layer-count {
    position: absolute;
    right: 27px;
    top: 0;
    height: 32px;
    display: flex;
    align-items: center;
}
.gjs-layer-move {
    padding: 0 10px 0 5px;
    position: absolute;
    font-size: 12px;
    cursor: move;
    right: 0;
    top: 0;
    height: 32px;
    display: flex;
    align-items: center;
}
.gjs-dashed [data-highlightable] {
    outline: 1px dashed rgba(170, 170, 170, 1);
    outline-offset: -1px;
}
.gjs-margin-v-el,
.gjs-fixedmargin-v-el {
  opacity: 0.3;
  filter: alpha(opacity=10);
  position: absolute;
  background-color: rgb(255, 217, 0);
}
.gjs-padding-v-el,
.gjs-fixedpadding-v-el {
  opacity: 0.2;
  filter: alpha(opacity=20);
  position: absolute;
  background-color: rgb(54, 0, 248);
}
.gjs-sm-clear {
  color: rgb(240, 23, 23);
  font-size: 16px;
}
.gjs-sm-sector .gjs-sm-property .gjs-sm-layer #gjs-sm-close-layer {
  top: 5px;
}
.gjs-sm-sector .gjs-sm-property .gjs-sm-layer > #gjs-sm-preview-box {
  top: 10px;
}
.gjs-sm-sector .gjs-sm-stack #gjs-sm-add {
  color: rgb(8, 125, 235);
  fill: rgb(8, 125, 235);
  right: 8px;
  font-size: 26px;
}
.gjs-sm-sector .gjs-sm-property.gjs-sm-file #gjs-sm-preview-box.gjs-sm-show{
  padding: 0;
}
.gjs-sm-sector .gjs-sm-property.gjs-sm-file .gjs-sm-show #gjs-sm-preview-file {
  height: 200px;
}
.gjs-sm-sector .gjs-sm-property.gjs-sm-file #gjs-sm-preview-box #gjs-sm-close {
  top: 0px;
  display: block;
  color: rgb(240, 23, 23);
  font-size: 24px;
}

.gjs-trt-traits, .gjs-clm-tags, .gjs-sm-properties {
  padding: 12px;
}
.gjs-clm-header, .gjs-clm-tags {
  margin: 0;
}
.gjs-clm-header {
  margin-bottom: 12px;
}
.gjs-clm-sels-info {
  margin: 0px;
}
.gjs-clm-tag {
  font-size: 12px;
  font-weight: 600;
  margin: 3px;
  padding: 6px 30px 6px 30px;
  position: relative;
  height: 32px;
  background-color: rgba(255,255,255,.8);
  color: black;
}
.gjs-clm-tags #gjs-clm-tags-field {
  padding: 8px;
  align-items: center;
}
.gjs-clm-tags #gjs-clm-checkbox {
  position: absolute;
  left: 4px;
  bottom: 4px;
  height: 16px;
  width: 16px;
  display: flex;
  color: rgb(0, 98, 209);
}
.gjs-clm-tags #gjs-clm-close {
  position: absolute;
  right: 4px;
  height: 16px;
  width: 16px;
  display: flex;
  color: black;
}
#gjs-clm-add-tag {
  position: relative;
  background-color: rgb(0, 98, 209);
  color: rgb(255, 255, 255);
  margin: 3px;
  height: 24px;
  width: 24px;
  transition: .3s;
}
#gjs-clm-add-tag::before {
  border-radius: inherit;
  bottom: 0;
  color: inherit;
  content: "";
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity .2s cubic-bezier(.4,0,.6,1);
  background-color: currentColor;
}
#gjs-clm-add-tag:hover::before {
  opacity: .08;
}
.gjs-clm-tags #gjs-clm-new {
  font-size: 12px;
  font-weight: 600;
  color: black;
}

.CodeMirror {
  background: #10161f !important;
  font-size: 11px;
  line-height: 2;
  height: 450px !important;
}
.CodeMirror-gutters {
  background: #070b10 !important;
  left: 0 !important;
}
.CodeMirror-lines {
  left: 0 !important;
}

.vjs-tree {
  font-size: 12px;
}
</style>
